import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const CoinPerformanceStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      minHeight: "251px",
      boxShadow: "3px 3px 10px 0 rgba(0,0,0,0.10)",
      borderRadius: "12px",
      padding: "20px 20px 0px 0px",
    },
    priceAlert: {
      cursor: "pointer",
      color: "#ccc3ae",
    },

    "@keyframes bellshake": {
      " 0%": { transform: "rotate(0)" },
      "15%": { transform: "rotate(5deg)" },
      "30%": { transform: "rotate(-5deg)" },
      " 45% ": { transform: "rotate(4deg)" },
      "60%": { transform: "rotate(-4deg)" },
      " 75% ": { transform: "rotate(2deg) " },
      " 85% ": { transform: " rotate(-2deg)" },
      "92% ": { transform: "rotate(1deg)" },
      "100% ": { transform: "rotate(0)" },
    },
    notificationIcon: {
      "&:hover": {
        animation: `$bellshake .5s cubic-bezier(.36,.07,.19,.97) both`,
        backfaceVisibility: "hidden",
        transformOrigin: "top right",
      },
    },

    watchListIcon: {
      marginTop: "4px",
    },
    logoImage: {
      borderRadius: "50%",
      height: "35px",
      width: "35px",
    },
    title: {
      fontSize: "18px",
      lineHeight: "1.2",
      fontWeight: theme.typography.fontWeightMedium,
      // up from tablet
      [theme.breakpoints.up("sm")]: {
        fontSize: "24px",
      },
    },
    subTitle: {
      fontSize: "12px",
      // up from tablet
      [theme.breakpoints.up("sm")]: {
        fontSize: "16px",
      },
      fontWeight: theme.typography.fontWeightRegular,
    },
    value: {
      wordWrap: "break-word",
      fontSize: "18px",
      lineHeight: "1.2",
      fontWeight: theme.typography.fontWeightRegular,
      // up from tablet
      [theme.breakpoints.up("sm")]: {
        fontSize: "24px",
      },
      // up from desktop
      [theme.breakpoints.up("md")]: {
        wordWrap: "none",
        fontSize: "40px",
        color: "#252525",
        paddingLeft: "10px",
        fontweight: theme.typography.fontWeightMedium,
      },
    },
    valueWrapper: {
      textAlign: "end",
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    iconWrapper: {
      paddingLeft: "20px",
      alignSelf: "center",
    },
    optionsContainer: {
      padding: "5px 0px 15px 0px",
      marginLeft: "10px",
      [theme.breakpoints.up("md")]: {
        padding: "5px 5px 0px 5px",
        justifyContent: "flex-end",
      },
    },
    candleIcon: {
      borderRadius: `20px`,
      width: "55px",
      height: "40px",
    },
    selectedCandle: {
      background: `rgba(179,124,130,0.20)`,
      borderRadius: `20px`,
      width: "55px",
      height: "40px",
      marginTop: "2px",
    },
    item: {
      borderRadius: `20px`,
      width: "55px",
      height: "40px",
      cursor: "pointer",
      textAlign: "center",
      paddingTop: "8px",
      marginTop: "2px",
      "& :hover": {
        backgroundColor: "red",
      },
      "& :active": {
        backgroundColor: "yellow",
      },
    },
    selected: {
      background: `rgba(179,124,130,0.20)`,
      borderRadius: `20px`,
      width: "55px",
      height: "40px",
      color: theme.palette.secondary.main,
      textAlign: "center",
      paddingTop: "8px",
      marginTop: "2px",
      fontWeight: theme.typography.fontWeightMedium,
    },
    hideOnMobile: {
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
    hideOnDesktop: {
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    headerTitleWrapper: {
      display: "flex",
      marginBottom: "10px",
    },
    desktopTitle: {
      fontSize: "24px",
      fontWeight: theme.typography.fontWeightBold,
      color: "#252525",
    },
    symbol: {
      fontSize: "24px",
      fontWeight: theme.typography.fontWeightRegular,
      color: "#545454",
      alignSelf: "center",
    },
    eyeContainer: {},
    gains: {
      color: "#01C0AA",
      fontSize: "14px",
      marginTop: "4px",
    },
    loses: {
      color: "red",
      fontSize: "14px",
      marginTop: "4px",
    },
    arrow: {
      marginTop: "20px",
      alignSelf: "center",
    },
    candleStick: {
      cursor: "pointer",

      padding: "8px",
      borderRadius: "50px",
      "& :focus": {
        backgroundColor: "lightGrey",
      },
    },
  }),
);
